/**
 * @return {{click: string}}
 */
export const userMenu = () => ({
  click: 'mon_profil',
});
